

import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import StateComponents from '../../../components/state-component/StateComponents'
import ManageStateComplaintList from './manageStateComplaintList'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall } from '../../../utils/app.utils'
import { IconComponent } from '../../../assets/icons/iconComponent'
import ContainerButton from '../../../components/button/ContainerButton'
import { COMPLAINTS_STATUS_DATA } from '../../students/complaint/enum/complaint.enum'
import { useTranslation } from 'react-i18next'
import { languageEnum } from '../../../constants/enum'

type Props = {}

const ComplaintList: React.FC<Props> = (props: Props) => {
    const { t, i18n } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        date_range,
        handleChangeDateRange,
        setSearch,
        complaint_type_data,
        id_complaints_type,
        set_id_complaints_type,
        set_search_complaint_type,
        handleDownloadReport,
        set_status,
        status
    } = ManageStateComplaintList()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("COMPLAINTS_MANAGE_DATA")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                                disabled_match: true,
                                pathName: routeName.cms.complaintSystem,
                            },
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_MANAGE_DATA"),
                                pathName: routeName.cms.complaintSystem
                            },
                        ]}
                    />
                }
                buttonContent={
                    <ContainerButton
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                buttonProps: {
                                    onClick: handleDownloadReport
                                },
                                key: "DOWNLOAD_CSV",
                                label: t("COMPLAINTS_DOWNLOAD_CSV"),
                                seq: 1,
                                type: "DOWNLOAD_CSV"
                            }
                        ]}
                    />
                }
                content={
                    <div className='w-full'>
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        placeholder: t("COMPLAINTS_SEARCH_CATEGORY_CREATOR_UPDATED"),
                                        startAdornment: <IconComponent.SearchIcon />,
                                        onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearch }),
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        getOptionLabel: (op) => op?.complaints_type_name || "",
                                        labelId: "id_complaints_type",
                                        onChange: (_: unknown, val: any) => set_id_complaints_type(val),
                                        onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_complaint_type }),
                                        placeholder: t("COMPLAINTS_ALL_CATEGORIES"),
                                        options: complaint_type_data || [],
                                        value: id_complaints_type
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        en: i18n.language === languageEnum.EN ? true : false,
                                        onchange: handleChangeDateRange,
                                        allowClear: true,
                                        onClear: () => handleChangeDateRange([]),
                                        placeholder: t("COMPLAINTS_DATE_RANGE"),
                                        value: date_range

                                    }
                                },
                                {
                                    seq: 4,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        getOptionLabel: (op) => t(op?.label) || "",
                                        labelId: "STATUS",
                                        onChange: (_, val) => set_status(val?.value),
                                        placeholder: t("COMPLAINTS_ALL_STATUSES"),
                                        options: COMPLAINTS_STATUS_DATA,
                                        value: COMPLAINTS_STATUS_DATA.find((x) => x.value === status) || null
                                    }
                                },
                            ]}
                        />

                        <div className='mt-10'>
                            <section className='w-full mt-10'>
                                <TableCustom
                                    tableMinWidth={1920}
                                    tableFixedWidth
                                    customScroll
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortBy={sortBy}
                                    sortType={sortType}
                                    headCells={headCells}
                                    rowCount={totalItems}
                                    rowsData={data?.map((data: any, i: any) => {
                                        return renderData(data, i)
                                    })}
                                    onSort={handleRequestSort}
                                    setPageLimit={(value: number) => setPageLimit(value)}
                                    setPage={(value: number) => setPage(value)}
                                />
                            </section>
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default ComplaintList